<template>
    <generic-page>
        <back-to-dashboard />

        <h5 class="mb-3">{{ $t("Settings") }}</h5>

        <div v-if="brand.enableInviteRewards" class="rounded p-3 bg-white mb-3">
            <b-form-checkbox v-model="privateInvitePage" switch>
                <strong>{{ $t("Private invite page") }}</strong>
            </b-form-checkbox>
            <div class="small text-secondary mt-2">
                <font-awesome-icon
                    icon="fa-duotone fa-info-circle"
                    class="mr-1"
                />
                {{
                    $t(
                        "When this is on, your invite page will not show your name or photo. This usually results in fewer signups."
                    )
                }}
            </div>
        </div>

        <div v-if="brand.enableRequest" class="rounded p-3 bg-white mb-3">
            <b-form-checkbox v-model="receiveRequests" switch>
                <strong>{{ $t("Receive requests") }}</strong>
            </b-form-checkbox>
            <div class="small text-secondary mt-2">
                <font-awesome-icon
                    icon="fa-duotone fa-info-circle"
                    class="mr-1"
                />
                {{
                    $t(
                        "When this is on, customers can send you paid content requests. Turning it off may reduce your earnings. To block specific users or countries, use the block option on their profile instead."
                    )
                }}
            </div>
        </div>

        <div class="rounded p-3 bg-white mb-3">
            <b-form-checkbox v-model="showAllCountries" switch>
                <strong>{{ $t("Show all countries") }}</strong>
            </b-form-checkbox>
            <div class="small text-secondary mt-2">
                <font-awesome-icon
                    icon="fa-duotone fa-info-circle"
                    class="mr-1"
                />
                {{
                    $t(
                        "By default, we show you customers from our target countries. Turn this on to view customers from all countries. You can always block any country you're not interested in from a customer's profile."
                    )
                }}
            </div>

            <div v-if="!showAllCountries" class="small mt-2">
                <font-awesome-icon
                    icon="fa-duotone fa-globe"
                    class="mr-1 text-primary"
                />
                <span v-if="loadingReachCount" class="text-secondary">
                    {{ $t("Calculating reach...") }}
                </span>
                <span v-else-if="reachCount > 0">
                    {{ $t("Turn this on to view up to") }}
                    <strong>{{ reachCount.toLocaleString() }}</strong>
                    {{ $t("additional customers worldwide.") }}
                </span>
            </div>
        </div>
    </generic-page>
</template>

<script>
import { mapState } from "vuex";

import BackToDashboard from "@/components/utility/BackToDashboard";

export default {
    data() {
        const user = this.$store.state.onboarding.user || {};

        return {
            privateInvitePage: !!user.creatorInvitePagePrivate,
            receiveRequests: !user.creatorDisableRequest,
            showAllCountries: !!user.creatorShowAllCountries,
            reachCount: null,
            loadingReachCount: false,
        };
    },
    computed: {
        ...mapState("brand", ["brand"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    created() {
        if (!this.showAllCountries) {
            this.fetchReachCount();
        }
    },
    watch: {
        privateInvitePage(value) {
            this.api
                .post("/creatorSetting/privateInvitePage", {
                    enable: value,
                })
                .then(() => {
                    this.$store.dispatch("onboarding/status");
                });
        },
        receiveRequests(value) {
            const endpoint = value
                ? "/userFlag/creatorEnableRequests"
                : "/userFlag/creatorDisableRequests";

            this.api.post(endpoint).then(() => {
                this.$store.dispatch("onboarding/status");
            });
        },
        showAllCountries(value) {
            this.api
                .post("/creatorSetting/showAllCountries", {
                    enable: value,
                })
                .then(() => {
                    this.$store.dispatch("onboarding/status");
                });

            if (!value && this.reachCount === null) {
                this.fetchReachCount();
            }
        },
    },
    methods: {
        fetchReachCount() {
            this.loadingReachCount = true;
            this.api
                .post("/creatorSetting/showAllCountriesUserCount")
                .then((response) => {
                    this.reachCount = response.data.count;
                })
                .finally(() => {
                    this.loadingReachCount = false;
                });
        },
    },
    components: {
        BackToDashboard,
    },
};
</script>
